import React, { useState, useCallback, useEffect } from 'react'
import { DataGrid } from 'Components/LifeDataGrid'
import { Container, Typography, useMediaQuery, useTheme } from '@mui/material'
// import Snackbar from '@mui/material/Snackbar'
// import Alert from '@mui/material/Alert'
import Button from '@mui/material/Button'
import ButtonGroup from '@mui/material/ButtonGroup'
import Box from '@mui/material/Box'
// import DeleteIcon from '@mui/icons-material/Delete'
// import EditIcon from '@mui/icons-material/Edit'
// import PreviewIcon from '@mui/icons-material/Preview'
import LinkIcon from '@mui/icons-material/Link'
import Tooltip from '@mui/material/Tooltip'
import EditOperationForm from '../EditOperationForm'
import { convertToUserDateFormate } from 'utils/helpers'
import { useSelector } from 'react-redux'
// import PDFViewer from '../PDFViewerTab'
// import { Document, Page } from 'react-pdf'
// import Dialog from '@mui/material/Dialog'
// import DialogTitle from '@mui/material/DialogTitle'
import FileDownloadIcon from '@mui/icons-material/FileDownload'
import { useFocusHighlight, FOCUS_ROW_CLASS, focusRowSx } from 'utils/useFocusHighlight' // LAP — deep-link
function ListOperations({ fetchOperations, operations, setSelectedRows, setOperations }) {
  const siteUser = useSelector((store) => store.user)
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  // LAP — surligne le document ciblé par une carte SmartFeed (/documents?focus=<id>)
  const { isFocused } = useFocusHighlight()
  const [rows, setRows] = useState(20)
  const [page, setPage] = useState(0)
  const [modifiedColumns, setModifiedColumns] = useState([])

  // const [numPages, setNumPages] = useState(null)
  useEffect(() => {
    if (isMobile) {
      setModifiedColumns([
        {
          field: 'Nom',
          headerName: 'Nom',
          // width: 280,
          flex: 1,

          // valueGetter: (params) => `${params.row.Nom?.Nom || params.row.IBAN}`,
          renderCell: (params) => {
            let val = ''
            if (params.row.Affectation != null) val = `Comptes-${params.row.Affectations.Noms}`
            else if (params.row.Immobilier != null) val = `Immobilier-${params.row.Immobiliers.nom}`
            else if (params.row.Vehicledata != null) val = `Véhicules-${params.row.vehicles.Name}`
            else if (params.row.PlanMaintenance != null)
              val = `PlanMaintenance-${params.row.PlanMaintenances.EquipementName}`
            else if (params.row.ParcoursPro != null)
              val = `ParcoursPro-${params.row.ParcoursPros.Name}`
            else if (params.row.TaskMesToDo != null)
              val = `TaskMesToDo-${params.row.TaskMesToDos.Nom}`

            return (
              <Box py={2} mt={1}>
                <Box fontWeight={600}>{params.row.Nom}</Box>
                <Box>
                  <Box component={'span'}>Type:</Box>{' '}
                  <Box component={'span'} fontWeight={600}>
                    {params.row.Types?.Type}
                  </Box>
                </Box>
                <Box>
                  <Box component={'span'}>Description:</Box>{' '}
                  <Box component={'span'} fontWeight={600}>
                    {params.row.Description}
                  </Box>
                </Box>
                <Box>
                  <Box component={'span'}>N° externe:</Box>{' '}
                  <Box component={'span'} fontWeight={600}>
                    {params.row.Externe}
                  </Box>
                </Box>
                <Box>
                  <Box component={'span'}>Date d’import:</Box>{' '}
                  <Box component={'span'} fontWeight={600}>
                    {convertToUserDateFormate(siteUser.user, params.row.Datedimport)}
                  </Box>
                </Box>
                <Box>
                  <Box component={'span'}>Affectation:</Box>{' '}
                  <Box component={'span'} fontWeight={600}>
                    {val}
                  </Box>
                </Box>
                <Box>
                  <Box component={'span'}>Categorie:</Box>{' '}
                  <Box component={'span'} fontWeight={600}>
                    {params.row.Types.categorie}
                  </Box>
                </Box>
                <Box>
                  <Box component={'span'}>Domains:</Box>{' '}
                  <Box component={'span'} fontWeight={600}>
                    {params.row.Types.Domains}
                  </Box>
                </Box>
              </Box>
            )
          },
        },
        {
          field: 'Datedéchéance',
          headerName: 'Date d’échéance',
          cellClassName: 'dtcell',
          flex: 1,
          renderCell: (params) => {
            return (
              <Box pt={1} width={'100%'}>
                <Box fontWeight={600} display={'flex'} justifyContent={'end'}>
                  {convertToUserDateFormate(siteUser.user, params.row.Datedéchéance)}
                </Box>

                <Box display={'flex'} justifyContent={'end'} width={'100%'} mt={3}>
                  <FileDownloadIcon sx={{ color: '#4a92d3', fontSize: 40, mr: 2 }} />
                </Box>
              </Box>
            )
          },
          maxWidth: 130,
        },
      ])
    } else {
      setModifiedColumns(columns)
    }
  }, [isMobile])
  const columns = [
    // { field: 'id', headerName: 'ID', width: 90 },
    {
      field: 'Type',
      headerName: 'Type',
      width: 130,
      valueGetter: (params) => `${params.row.Types?.Type}`,
    },
    {
      field: 'Nom',
      headerName: 'Nom',
      width: 130,
      renderCell: (params) => params.row.Nom,
    },
    {
      field: 'Description',
      headerName: 'Description',
      width: 200,
    },
    {
      field: 'Externe',
      headerName: 'N° externe',
      width: 120,
    },
    {
      field: 'Datedimport',
      headerName: 'Date d’import',
      type: 'date',
      width: 100,
      valueGetter: (params) => convertToUserDateFormate(siteUser.user, params.row.Datedimport),
    },
    {
      field: 'Datedéchéance',
      headerName: 'Date d’échéance',
      type: 'date',
      width: 120,
      renderCell: (params) => convertToUserDateFormate(siteUser.user, params.row.Datedéchéance),
    },
    {
      field: 'Affectation',
      headerName: 'Affectation',
      width: 230,
      valueGetter: (params) => {
        let val = ''
        if (params.row.Affectation != null) val = `Comptes-${params.row.Affectations.Noms}`
        else if (params.row.Immobilier != null) val = `Immobilier-${params.row.Immobiliers.nom}`
        else if (params.row.Vehicledata != null) val = `Véhicules-${params.row.vehicles.Name}`
        else if (params.row.PlanMaintenance != null)
          val = `PlanMaintenance-${params.row.PlanMaintenances.EquipementName}`
        else if (params.row.ParcoursPro != null) val = `ParcoursPro-${params.row.ParcoursPros.Name}`
        else if (params.row.TaskMesToDo != null) val = `TaskMesToDo-${params.row.TaskMesToDos.Nom}`
        return val
      },
    },
    {
      field: 'Categorie',
      headerName: 'Categorie',
      width: 140,
      valueGetter: (params) => `${params.row.Types.categorie}`,
    },
    {
      field: 'Domains',
      headerName: 'Domains',
      width: 160,
      valueGetter: (params) => `${params.row.Types.Domains}`,
    },
    {
      field: 'action',
      headerName: 'Action',
      renderCell: renderAction,
      width: 140,
    },
  ]
  // function onDocumentLoadSuccess({ numPages }) {
  //   setNumPages(numPages)
  //   // setPageNumber(1)
  // }
  const handleRowsChange = (newPageSize) => {
    setRows(newPageSize)
    let url = `&limit=${newPageSize}&offset=${page}`
    fetchOperations(url)
  }
  const handlePageChange = (newPage) => {
    setPage(newPage * rows)
    let url = `&limit=${rows}&offset=${newPage * rows}`
    fetchOperations(url)
  }
  // function handleClick(params) {
  //   window.open(params.row.Lien, '_blank')
  //   // return (<PDFViewerTab url={params.row.Lien}/>)
  // }
  // function renderPdf(params) {
  //   return (
  //     <>
  //       <Dialog fullWidth maxWidth="xs" open={true}>
  //         <DialogTitle>Éditer Opérations</DialogTitle>
  //       </Dialog>
  //     </>
  //     // <Document file={params} onLoadSuccess={onDocumentLoadSuccess}>
  //     //   {Array.from(new Array(numPages), (el, index) => (
  //     //     <Page key={`page_${index + 1}`} pageNumber={index + 1} />
  //     //   ))}
  //     // </Document>
  //   )
  // }
  function renderAction(params) {
    return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <ButtonGroup variant="text" aria-label="text button group">
          {/* 
          <EditOperationForm
            setOperations={setOperations}
            params={params}
            operations={operations}
          />

          <Tooltip title="View">
            <Button onClick={() => handleClick(params)}>
              <PreviewIcon />
            </Button>
          </Tooltip> */}
          <Tooltip title="Copy Link">
            <Button
              onClick={() => {
                navigator.clipboard.writeText(params.row.Lien)
              }}
            >
              <LinkIcon />
            </Button>
          </Tooltip>
        </ButtonGroup>
      </Box>
    )
  }

  return (
    <div
      style={{
        width: '100%',
        background: 'white',
        borderRadius: '5px',
      }}
    >
      <Typography
        variant="h6"
        sx={{
          flex: '1 1 100%',
          id: 'tableTitle',
          fontWeight: 600,
          padding: '10px',
          component: 'div',
        }}
      >
        Mes Documents ({operations.count})
      </Typography>
      <DataGrid
        sx={{
          height: 800,
          fontSize: isMobile ? '11px' : '13px',
          '.dtcell': { alignItems: 'flex-start' },
          ...focusRowSx, // LAP — surlignage deep-link
        }}
        rows={operations.results ? operations.results : []}
        columns={modifiedColumns}
        getRowHeight={() => (isMobile ? 'auto' : 50)}
        pageSize={rows}
        rowCount={operations.count ? operations.count : 0}
        onPageSizeChange={handleRowsChange}
        onPageChange={handlePageChange}
        rowsPerPageOptions={[10, 20, 40]}
        pagination
        onSelectionModelChange={(itm) => setSelectedRows([...itm])}
        paginationMode="server"
        checkboxSelection
        getRowClassName={(params) => (isFocused(params.id) ? FOCUS_ROW_CLASS : '')}
        disableSelectionOnClick
        onRowClick={(params, event) => {
          if (event.target.localName === 'div') {
            window.open(params.row.Lien)
          }
        }}
      />
    </div>
  )
}
export default ListOperations
